/**************************************************
 * Nombre:       Tarjeta_Contenido_Cap
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import React from "react";
import {TIPOSCONTENIDO} from "../../Constantes";
import {Player} from "video-react";
import ic_documento from '../../Recursos/ic_documento.svg'
import {descargarArchivo} from "../../Utilidades/descargarArchivo";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import {irUrl} from "../../Utilidades/irUrl";

const Tarjeta_Contenido_Cap = ({item}) => {


    const obtenerComponente = ({tipo, recurso}) => {

        switch (tipo) {
            case TIPOSCONTENIDO[0]: // video
                return (
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Player>
                            <source src={recurso} width={'100%'} height={'auto'} style={{borderRadius: 10}}/>
                        </Player>
                    </Grid>
                )
                break
            case TIPOSCONTENIDO[1]: // pdf
                return (
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <img
                                onClick={() => irUrl(recurso)}
                                src={ic_documento} width='50%' height={'auto'}
                                style={{cursor: 'pointer'}}
                            />
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Button
                                onClick={() => descargarArchivo(recurso, item.titulo + '.pdf')}
                            >Descargar</Button>
                        </Grid>

                    </Grid>

                )
                break
            case TIPOSCONTENIDO[2]: // imagen
                return (
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'center'}}>
                            <Zoom>
                                <img src={recurso} width='100%' height={'auto'}/>
                            </Zoom>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Button
                                onClick={() => descargarArchivo(recurso, item.titulo + '.png')}
                            >Descargar</Button>
                        </Grid>

                    </Grid>
                )
                break

        }

    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={4}
            sx={{pt: 4}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                {obtenerComponente({tipo: item.tipo, recurso: item.recurso})}
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={0}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 24, fontWeight: 700}}>{item.titulo}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography>{item.descripcion}</Typography>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Contenido_Cap